import { useState } from 'react';

export const usePreviousValue = <T>(initialValue: T) => {
   const [currentValue, setCurrentValue] = useState(initialValue);
   const [previousValues, setPreviousValues] = useState<T[]>([]);

   const setCurrentValueFn = (newValue: T) => {
      previousValues.push(currentValue);
      setCurrentValue(newValue);
   };

   const undoValue = () => {
      const tempPreviousValues = [...previousValues];
      const previousValue = tempPreviousValues.pop();
      if (previousValue) {
         setCurrentValue(previousValue);
         setPreviousValues(tempPreviousValues);
      }
   };

   const reset = () => {
      setCurrentValue(initialValue);
      setPreviousValues([]);
   };

   return [currentValue, setCurrentValueFn, undoValue, reset] as const;
};
